@if (pending) {
  <div class="spinner-container">
    <span class="spinner spinner-sm spinner-inverse"> </span>
  </div>
}
@if (contentEditable) {
  <div
    #numberHighlighter
    [contentEditable]="true"
    class="number-highlighter number-highlighter--editable-content"
    (blur)="changeInValue($any($event.target).textContent, true)"
    (focus)="focus()"
    (input)="onInput($any($event.target).textContent)"
  ></div>
} @else {
  @if (value) {
    <div class="number-highlighter-not-editable">
      @if (startAfterDecimal) {
        @if (value | split: '.'; as splitValue) {
          <span>{{ splitValue[0] }}</span>
          @if (splitValue[1]) {
            <span>.</span>
            <ng-container
              *ngTemplateOutlet="
                highlightNumbersTmpl;
                context: {
                  sectionToHighlight: splitValue[1]
                }
              "
            >
            </ng-container>
          }
        }
      } @else {
        <ng-container
          *ngTemplateOutlet="
            highlightNumbersTmpl;
            context: {
              sectionToHighlight: value
            }
          "
        >
        </ng-container>
      }
    </div>
  }

  <ng-template
    #highlightNumbersTmpl
    let-sectionToHighlight="sectionToHighlight"
  >
    <ng-container
      *ngFor="let splitNumber of sectionToHighlight | split; let idx = index"
    >
      @if (idx | includedIn: indicesToHighlight) {
        <span class="highlight-text">{{ splitNumber }}</span>
      } @else {
        <span>{{ splitNumber }}</span>
      }
    </ng-container>
  </ng-template>
}
